import React, { useState, useContext, useEffect } from 'react';
import AppContext from '../Context/AppContext';
import axios from 'axios';
import Loader from './Loader';
import { Eye, ArrowUp, ArrowDown, Search, Minus } from "lucide-react";

const StatSport = ({ targetUrl, label }) => {
    const repeatTask = 1;
    const { mapUrl } = useContext(AppContext)
    const [load, setLoad] = useState(true)

    const [contentMatchs, setContentMatchs] = useState([])
    const [contentChannels, setContentChannels] = useState([])
    const [data, setData] = useState(null)

    const [tab, setTab] = useState('matchs')
    const [search, setSearch] = useState('')

    const updateRanking = (newData, prevData) => {
        if (prevData.length > 0) {
            const previousRankMap = prevData.reduce((acc, item) => {
                acc[item.name] = item.classement;
                return acc;
            }, {});
            return newData.map((item, index) => {
                const previousRank = previousRankMap[item.name] || (index + 1);
                const changement = previousRank - (index + 1);
                return { ...item, classement: index + 1, changement };
            });
        }
        return newData.map((e, i) => ({ ...e, classement: i + 1, changement: null }));
    };

    const init = async () => {
        if (mapUrl.hasOwnProperty(targetUrl)) {
            const response = await axios.get(mapUrl[targetUrl]);
            if (response?.data) {
                const matchs = response.data?.matches?.length > 0 ? response.data.matches.slice(0, 10) : [];
                const channels = response.data?.channels?.length > 0 ? response.data.channels.slice(0, 10) : [];
                setContentMatchs(prev => updateRanking(matchs, prev));
                setContentChannels(prev => updateRanking(channels, prev));
                setData(response.data);
            }
        }
        setLoad(false);
    }

    useEffect(() => {
        init();
        const interval = setInterval(init, repeatTask * 60 * 1000);
        return () => clearInterval(interval);
    }, [])

    if (load) {
        return <div className='py2'><Loader /></div>
    }

    const list = tab === 'matchs' ? contentMatchs : contentChannels
    const total = tab === 'matchs' ? data?.totalMatchViewers : data?.totalChannelViewers
    const filtered = list.filter(it => (it.name || "").toLowerCase().includes(search.toLowerCase()))

    const rankClass = (r) => r === 1 ? "top1" : r === 2 ? "top2" : r === 3 ? "top3" : ""

    return (
        <div className='pb2 stat-sport'>
            <div className='df aic jcsb mb2'>
                <p className='cw fm fs18'>{label}</p>
                <div className='sport-total df aic gap1'>
                    <Eye size={15} color='#fff' /> {total ?? 0}
                </div>
            </div>

            {/* Filtres */}
            <div className='df gap1 mb2 sport-tabs'>
                <button className={tab === 'matchs' ? 'active' : ''} onClick={() => setTab('matchs')}>Matchs</button>
                <button className={tab === 'chaines' ? 'active' : ''} onClick={() => setTab('chaines')}>Chaînes</button>
            </div>

            {/* Recherche */}
            <div className='sport-search df aic gap1 mb2'>
                <Search size={17} color='#8f909c' />
                <input placeholder='Rechercher...' value={search} onChange={(e) => setSearch(e.currentTarget.value)} />
            </div>

            {/* Tableau */}
            <div className='sport-table'>
                <div className='sport-thead'>
                    <span>#</span>
                    <span>Nom</span>
                    <span className='tar'>Vues</span>
                    <span className='tar'>Évol.</span>
                </div>

                {filtered.map((item, i) => (
                    <div className='sport-row' key={i + "_sport"}>
                        <span className={`sport-rank ${rankClass(item.classement)}`}>{item.classement}</span>
                        <span className='sport-name'>{item.name}</span>
                        <span className='sport-views'><Eye size={13} color='#fff' /> {item.viewers}</span>
                        <span className='sport-change'>
                            {item.changement === null || item.changement === 0 ? (
                                <Minus size={14} color='#8f909c' />
                            ) : item.changement > 0 ? (
                                <><ArrowUp size={14} color='#15992f' /> {item.changement}</>
                            ) : (
                                <><ArrowDown size={14} color='#f71717' /> {Math.abs(item.changement)}</>
                            )}
                        </span>
                    </div>
                ))}

                {filtered.length === 0 && (
                    <p className='sport-empty'>Aucun résultat</p>
                )}
            </div>
        </div>
    );
};

export default StatSport;
